import React from 'react';
import {
  Platform,
  Pressable,
  StyleSheet,
  Text,
  View,
} from 'react-native';
import { colorSwatches } from '../styles';

const PendingApprovalsBadge = ({ pendingApprovals, onPress }) => {
  return (
    <Pressable
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={`${pendingApprovals} pending approval${pendingApprovals > 1 ? 's' : ''}`}
      accessibilityHint="Opens the pending approvals page"
      android_ripple={{ color: 'rgba(255,255,255,0.16)' }}
      style={({ pressed }) => [
        styles.banner,
        {
          opacity: pressed ? 0.92 : 1,
        },
      ]}>
      <View pointerEvents="none" style={styles.content}>
        <View style={styles.textBlock}>
          <Text style={styles.title}>
            {`${pendingApprovals} pending approval${pendingApprovals > 1 ? 's' : ''}`}
          </Text>
          <Text style={styles.subtitle}>Tap to review now</Text>
        </View>
        <View style={styles.cta}>
          <Text style={styles.ctaText}>VIEW</Text>
        </View>
      </View>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  banner: {
    backgroundColor: colorSwatches.red[400],
    paddingHorizontal: 14,
    paddingVertical: 12,
    minHeight: 68,
    justifyContent: 'center',
    elevation: 2,
    ...(Platform.OS === 'ios'
      ? {
          shadowColor: '#000000',
          shadowOpacity: 0.12,
          shadowRadius: 6,
          shadowOffset: {width: 0, height: 3},
        }
      : {}),
  },
  content: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  textBlock: {
    flex: 1,
    paddingRight: 12,
  },
  title: {
    fontSize: 18,
    fontWeight: '700',
    color: colorSwatches.white.color,
  },
  subtitle: {
    marginTop: 2,
    fontSize: 13,
    color: colorSwatches.white.color,
  },
  cta: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 9999,
    backgroundColor: 'rgba(255,255,255,0.18)',
  },
  ctaText: {
    color: colorSwatches.white.color,
    fontSize: 12,
    fontWeight: '700',
    letterSpacing: 0.5,
  },
});

export default PendingApprovalsBadge;
